// extracted by mini-css-extract-plugin
export default {"displayInline":"styles_displayInline__JRj2D","joiningText":"styles_joiningText__7Kgnr"};